import { z } from 'zod';

export const restaurantSchema = z
  .object({
    restaurant_id: z.number(),
    user_id: z.number(),
    name: z.string(),
    address: z.string(),
    city_id: z.number(),
    city: z.string(),
    state: z.string(),
    state_code: z.string().nullable(),
    zip: z.string(),
    full_address: z.string(),
    image_url: z.string().nullable(),
    order_status: z.boolean(),
    is_stripe_added: z.boolean(),
    has_menu_items: z.boolean().nullable(),
    is_restaurant_open: z.boolean(),
    last_modified_order_status: z.string(),
    cancellation_status: z.boolean(),
    about: z.string().nullable(),
    status: z.boolean(),
    business_hour_status: z.boolean(),
    created_at: z.string(),
    updated_at: z.string(),
    schedule: z.string().nullable(),
    rating: z.object({
      average_rating: z.string().transform((value) => parseFloat(value)),
      count: z.number(),
    }),
    business_hour: z
      .object({
        opening_time: z.string(),
        closing_time: z.string(),
      })
      .partial(),
    tags: z.array(
      z
        .object({
          tag_id: z.number(),
          name: z.string(),
        })
        .partial(),
    ),
    background_image_url: z.string().nullable(),
  })
  .strict();

export type Restaurant = z.infer<typeof restaurantSchema>;

export const restaurantServiceDataSchema = z.object({
  total_pages: z.number(),
  current_page: z.number(),
  previous_page: z.any(),
  next_page: z.any(),
  items_per_page: z.number(),
  total_data: z.number(),
  data: z.array(restaurantSchema),
});
